import React from 'react';
import { IconButton, Typography, useTheme } from '@mui/material';
import { CohortListRow, LinkIcon } from '@/components/Hypertracker/HyperSearch/HyperSearchStyled';
import { highlightMatch } from './highlightMatch';
import { SearchResultEntry } from './unifiedSearchTypes';

interface UnifiedSearchRowProps {
    entry: SearchResultEntry;
    searchText: string;
    isFocused: boolean;
    onClick: () => void;
}

const UnifiedSearchRow: React.FC<UnifiedSearchRowProps> = ({
    entry,
    searchText,
    isFocused,
    onClick,
}) => {
    const theme = useTheme();

    return (
        <CohortListRow
            sx={{
                minWidth: '350px',
                backgroundColor: isFocused ? `${theme.palette.hyperLiquidColor}1A` : '',
            }}
            onClick={onClick}
            onMouseDown={(event) => event.preventDefault()}
        >
            <Typography color={'common.white'} variant={'p12'}>
                <Typography component={'span'} color={'customText.text1'} variant={'p12'}>
                    {`${entry.label}: `}
                </Typography>
                {highlightMatch(entry.displayValue, searchText, theme.palette.hyperLiquidColor)}
            </Typography>
            <IconButton
                onClick={(event) => {
                    event.stopPropagation();
                    onClick();
                }}
            >
                <LinkIcon />
            </IconButton>
        </CohortListRow>
    );
};

export default UnifiedSearchRow;
